import { render, staticRenderFns } from "./document-status.vue?vue&type=template&id=125bd66f"
import script from "./document-status.vue?vue&type=script&lang=js"
export * from "./document-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports